<template>
    <div class="content-box">
        <Title/>

        <Echarts/>
    </div>
</template>

<script>
export default {
    name: "unicorn",
    data() {
        return {
            params: {
                dataNav: [
                    {
                        name: "估值",
                        data: "shares",
                    },
                    {
                        name: "所在地",
                        data: "a100",
                    },
                    {
                        name: "成立时间",
                        data: "dtime",
                    },
                ],
                name: '',
                cate: '产业电商',
                time: new Date().getFullYear(),
                chen: '独角兽'
            }
        }
    },
    created() {
        this.$store.dispatch('getUnicorn', this.params)
    }
};
</script>

<style>
</style>